/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FileDto } from '../models/file-dto';
import { PageInfoDto } from '../models/page-info-dto';
import { storageControllerDeleteFile } from '../fn/storage/storage-controller-delete-file';
import { StorageControllerDeleteFile$Params } from '../fn/storage/storage-controller-delete-file';
import { storageControllerDeleteMany } from '../fn/storage/storage-controller-delete-many';
import { StorageControllerDeleteMany$Params } from '../fn/storage/storage-controller-delete-many';
import { storageControllerFindById } from '../fn/storage/storage-controller-find-by-id';
import { StorageControllerFindById$Params } from '../fn/storage/storage-controller-find-by-id';
import { storageControllerGetCountByClientId } from '../fn/storage/storage-controller-get-count-by-client-id';
import { StorageControllerGetCountByClientId$Params } from '../fn/storage/storage-controller-get-count-by-client-id';
import { storageControllerRenderImage } from '../fn/storage/storage-controller-render-image';
import { StorageControllerRenderImage$Params } from '../fn/storage/storage-controller-render-image';
import { storageControllerSearchOffset } from '../fn/storage/storage-controller-search-offset';
import { StorageControllerSearchOffset$Params } from '../fn/storage/storage-controller-search-offset';
import { storageControllerUploadFiles } from '../fn/storage/storage-controller-upload-files';
import { StorageControllerUploadFiles$Params } from '../fn/storage/storage-controller-upload-files';

@Injectable({ providedIn: 'root' })
export class StorageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storageControllerFindById()` */
  static readonly StorageControllerFindByIdPath = '/api/storage/{id}';

  /**
   * 파일 조회.
   *
   * 입력한 ID에 해당하는 파일을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerFindById$Response(params: StorageControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
    return storageControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 조회.
   *
   * 입력한 ID에 해당하는 파일을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerFindById(params: StorageControllerFindById$Params, context?: HttpContext): Observable<FileDto> {
    return this.storageControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDto>): FileDto => r.body)
    );
  }

  /** Path part for operation `storageControllerRenderImage()` */
  static readonly StorageControllerRenderImagePath = '/api/storage/{id}/render';

  /**
   * 이미지 파생본 조회.
   *
   * 입력한 해상도와 fit 기준으로 캐시된 이미지 파생본을 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerRenderImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerRenderImage$Response(params: StorageControllerRenderImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return storageControllerRenderImage(this.http, this.rootUrl, params, context);
  }

  /**
   * 이미지 파생본 조회.
   *
   * 입력한 해상도와 fit 기준으로 캐시된 이미지 파생본을 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerRenderImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerRenderImage(params: StorageControllerRenderImage$Params, context?: HttpContext): Observable<void> {
    return this.storageControllerRenderImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `storageControllerGetCountByClientId()` */
  static readonly StorageControllerGetCountByClientIdPath = '/api/storage/count/{clientWorkspaceId}';

  /**
   * 관리중 파일 수 조회.
   *
   * 관리중인 파일 수를 고객사 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerGetCountByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerGetCountByClientId$Response(params: StorageControllerGetCountByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return storageControllerGetCountByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리중 파일 수 조회.
   *
   * 관리중인 파일 수를 고객사 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerGetCountByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerGetCountByClientId(params: StorageControllerGetCountByClientId$Params, context?: HttpContext): Observable<number> {
    return this.storageControllerGetCountByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `storageControllerSearchOffset()` */
  static readonly StorageControllerSearchOffsetPath = '/api/storage/search/offset';

  /**
   * 파일 검색.
   *
   * 파일을 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerSearchOffset$Response(params: StorageControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<FileDto>;
'pageInfo'?: PageInfoDto;
}>> {
    return storageControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 검색.
   *
   * 파일을 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerSearchOffset(params: StorageControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items'?: Array<FileDto>;
'pageInfo'?: PageInfoDto;
}> {
    return this.storageControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'items'?: Array<FileDto>;
'pageInfo'?: PageInfoDto;
}>): {
'items'?: Array<FileDto>;
'pageInfo'?: PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `storageControllerUploadFiles()` */
  static readonly StorageControllerUploadFilesPath = '/api/storage/{container}';

  /**
   * 파일 업로드.
   *
   * 파일을 업로드합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerUploadFiles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storageControllerUploadFiles$Response(params: StorageControllerUploadFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileDto>>> {
    return storageControllerUploadFiles(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 업로드.
   *
   * 파일을 업로드합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerUploadFiles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storageControllerUploadFiles(params: StorageControllerUploadFiles$Params, context?: HttpContext): Observable<Array<FileDto>> {
    return this.storageControllerUploadFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FileDto>>): Array<FileDto> => r.body)
    );
  }

  /** Path part for operation `storageControllerDeleteFile()` */
  static readonly StorageControllerDeleteFilePath = '/api/storage/{url}';

  /**
   * 파일 삭제.
   *
   * 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerDeleteFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerDeleteFile$Response(params: StorageControllerDeleteFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
    return storageControllerDeleteFile(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 삭제.
   *
   * 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerDeleteFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerDeleteFile(params: StorageControllerDeleteFile$Params, context?: HttpContext): Observable<FileDto> {
    return this.storageControllerDeleteFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDto>): FileDto => r.body)
    );
  }

  /** Path part for operation `storageControllerDeleteMany()` */
  static readonly StorageControllerDeleteManyPath = '/api/storage';

  /**
   * 여러 파일 삭제.
   *
   * 여러 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerDeleteMany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storageControllerDeleteMany$Response(params: StorageControllerDeleteMany$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'count'?: number;
}>> {
    return storageControllerDeleteMany(this.http, this.rootUrl, params, context);
  }

  /**
   * 여러 파일 삭제.
   *
   * 여러 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerDeleteMany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storageControllerDeleteMany(params: StorageControllerDeleteMany$Params, context?: HttpContext): Observable<{
'count'?: number;
}> {
    return this.storageControllerDeleteMany$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'count'?: number;
}>): {
'count'?: number;
} => r.body)
    );
  }

}
